import { ApiType } from "@gymflow/common";
import { FacilityDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { facilityQueryKeys } from "./facilityQueryKeys";

export async function facilityQueryFn({
  api,
  facilityId,
}: {
  api: ApiType;
  facilityId: number;
}) {
  return (await api.facilityApi.findById(facilityId)).data;
}

export function useFacility(
  {
    api,
    facilityId,
  }: {
    api: ApiType;
    facilityId?: number;
  },
  opts?: Omit<UseQueryOptions<FacilityDTO>, "queryKey">,
) {
  return useQuery({
    queryKey: facilityQueryKeys.details(facilityId as number),
    queryFn: () => facilityQueryFn({ api, facilityId: facilityId as number }),
    enabled: !!facilityId,
    ...opts,
  });
}
